// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ButtonIconTransparent_disabled__siE8e","inverse":"ButtonIconTransparent_inverse__ihoQ4","default":"ButtonIconTransparent_default__0aYN2"};